module.exports = __webpack_public_path__ + "static/media/guide_line_2.3feec282.png";